// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* History Insights View - Sidebar Layout */

/* Note: Removed overflow-y: hidden rule to allow page scrolling when sidebar is open */

/* Main container - SIDEBAR LAYOUT */
.history-insights-view {
    position: fixed;
    top: 0;
    right: 0;
    width: 500px; /* default, can be overridden inline */
    height: 100vh;
    background: #000000;
    -webkit-backdrop-filter: blur(20px);
    backdrop-filter: blur(20px);
    border-left: 1px solid rgba(75, 85, 99, 0.2);
    display: flex;
    flex-direction: column;
    z-index: 100002;
    transform: translateX(100%);
    transition: transform 0.3s ease-in-out;
    box-shadow: -4px 0 20px rgba(0, 0, 0, 0.3);
}

/* Remove the old close button styles since we're using single toggle */

/* Scrollable content container */
.sidebar-scrollable-content {
    flex: 1;
    overflow-y: auto; /* show native scrollbar */
    overflow-x: hidden;
    display: flex;
    flex-direction: column;
    padding-top: 16px; /* More top spacing to avoid overlap with fixed close button */
    /* Show native scrollbar for the history sidebar */
    scrollbar-width: auto;
    -ms-overflow-style: auto;
}

.sidebar-scrollable-content::-webkit-scrollbar { width: 8px; height: 8px; }

.sidebar-scrollable-content::-webkit-scrollbar-track {
    background: transparent;
}

.sidebar-scrollable-content::-webkit-scrollbar-thumb {
    background-color: rgba(75, 85, 99, 0.3);
    border-radius: 3px;
}

.sidebar-scrollable-content::-webkit-scrollbar-thumb:hover {
    background-color: rgba(75, 85, 99, 0.6);
}

.history-insights-view.open {
    transform: translateX(0);
}

.history-insights-view .insights-panel {
    flex: 1 1 auto;
    min-height: 0; /* allow inner content to size and scroll */
    overflow: hidden; /* avoid double scrollbars */
}

/* History bar styling */
.history-insights-view .history-bar {
    background: #000000;
    border-bottom: 1px solid rgba(75, 85, 99, 0.2);
    flex-shrink: 0;
    padding-right: 44px; /* ensure Clear All doesn't clash with top-right close button */
    padding-top: 1.5rem; /* extra space above Recent Activity */
    text-align: center;
}

/* Center the header container */
.history-insights-view .history-bar .flex.items-center.justify-between {
    justify-content: center !important;
    position: relative;
}

/* Position Clear All button absolutely */
.history-insights-view .history-bar .flex.items-center.justify-between button {
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
}

/* Center the Recent Activity title and icon */
.history-insights-view .history-bar .flex.items-center.gap-3 {
    justify-content: center;
}

.history-insights-view .history-bar > div:first-child {
    justify-content: center;
}

.history-insights-view .history-bar h2 {
    text-align: center;
}

/* Empty state styling - remove black background */
.history-bar .text-center,
.history-insights-view .text-center {
    text-align: center !important;
    padding: 1rem;
    background: transparent;
    border: none;
    border-radius: 12px;
    margin-top: 1rem;
    display: flex;
    align-items: center;
    justify-content: center;
}

.history-bar .text-center > div,
.history-insights-view .text-center > div {
    color: rgba(255, 255, 255, 0.3);
    font-size: 0.75rem;
    font-weight: 400;
    letter-spacing: 0.01em;
    line-height: 1.4;
    text-align: center;
}

/* Stacked insights panel styling */
.insights-panel-stacked {
    flex: 1;
    min-height: 400px; /* Minimum height to ensure content is visible */
    margin-top: 0;
    border-top: 1px solid rgba(75, 85, 99, 0.2);
}

/* History toggle button */
.history-toggle {
    position: fixed;
    top: 4px;
    right: 4px;
    width: 40px !important;
    height: 40px !important;
    background: transparent;
    -webkit-backdrop-filter: none;
    backdrop-filter: none;
    border: none;
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    z-index: 9999;
    transition: all 0.15s ease;
    color: rgba(255, 255, 255, 0.85);
}

/* Default state (closed) - hover */
.history-toggle:hover { background: transparent; color: rgba(255, 255, 255, 0.95); }

/* Open state - hover for close */
.history-toggle.open:hover { background: transparent; color: rgba(255, 255, 255, 0.95); }

.history-toggle svg {
    width: 18px !important;
    height: 18px !important;
    stroke-width: 2;
}

/* Ensure desktop sizing is explicit */
@media (min-width: 769px) {
    .history-toggle {
        width: 40px !important;
        height: 40px !important;
    }
    
    .history-toggle svg {
        width: 18px !important;
        height: 18px !important;
    }
}

/* Backdrop overlay for mobile */
.history-backdrop {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.5);
    z-index: 100001;
    opacity: 0;
    visibility: hidden;
    transition: opacity 0.3s ease, visibility 0.3s ease;
    display: none; /* Hidden by default, shown on mobile */
}

.history-backdrop.visible {
    opacity: 1;
    visibility: visible;
}

.history-insights-view h2 {
    font-size: 0.95rem;
    font-weight: 600;
    color: #ffffff;
    letter-spacing: -0.01em;
}

.history-insights-view .history-item {
    border-radius: 9999px;
    background: rgba(255, 255, 255, 0.06);
    border: 1px solid rgba(255, 255, 255, 0.12);
    color: rgba(229, 231, 235, 0.9);
}

.history-insights-view .history-item.selected {
    background: rgba(255, 255, 255, 0.14);
    border-color: rgba(255, 255, 255, 0.28);
    color: #ffffff;
}

.history-insights-view .history-item .item-label {
    color: inherit;
}

.history-insights-view .history-item:hover {
    border-color: rgba(255, 255, 255, 0.16);
}

.history-insights-view .history-list {
    scrollbar-width: thin;
    scrollbar-color: rgba(75, 85, 99, 0.3) transparent;
}

.history-insights-view .history-list::-webkit-scrollbar {
    height: 6px;
}

.history-insights-view .history-list::-webkit-scrollbar-track {
    background: transparent;
}

.history-insights-view .history-list::-webkit-scrollbar-thumb {
    background-color: rgba(75, 85, 99, 0.3);
    border-radius: 3px;
}

.history-insights-view .history-list::-webkit-scrollbar-thumb:hover {
    background-color: rgba(75, 85, 99, 0.6);
}

.history-insights-view .keywords-section h3,
.history-insights-view .companies-section h3 {
    color: rgba(209, 213, 219, 0.9);
}

.history-insights-view .history-item:hover {
    transform: none;
}

.history-insights-view .history-remove-button {
    color: rgba(156, 163, 175, 0.8);
    background: transparent;
    border: 0;
    border-radius: 9999px;
    transition: color 0.2s ease, background 0.2s ease;
}

.history-insights-view .history-remove-button:hover {
    color: #fca5a5;
    background: rgba(239, 68, 68, 0.1);
}

/* === RESPONSIVE DESIGN === */
.history-resize-handle {
    position: absolute;
    top: 0;
    left: 0;
    width: 6px;
    height: 100%;
    cursor: col-resize;
    z-index: 100004; /* above content */
    background: transparent;
}

.history-resize-handle:hover,
.history-resize-handle.dragging {
    background: linear-gradient(to right, rgba(255,255,255,0.08), transparent);
}

@media (max-width: 1200px) {
    .history-insights-view {
        width: 500px;
    }
}

@media (max-width: 768px) {
    .history-insights-view {
        width: 100vw;
        height: 100dvh; /* Use dynamic viewport height on mobile */
        border-left: none;
        border-top: 1px solid rgba(75, 85, 99, 0.2);
    }

    /* Hide resize handle on mobile */
    .history-resize-handle {
        display: none;
    }
    
    .history-backdrop {
        display: block;
    }
    
    .history-toggle {
        top: 4px;
        right: 4px;
        width: 40px;
        height: 40px;
    }
    
    .history-toggle svg {
        width: 18px;
        height: 18px;
    }
    
    /* Mobile styles for single toggle button */
    
    .history-insights-view .history-bar {
        padding: 0.5rem;
    }
    
    .history-insights-view .history-bar .grid {
        grid-template-columns: 1fr;
        gap: 1rem;
    }
}

/* Save keyword button styles */
.save-keyword-button {
    border-radius: 4px;
    transition: all 0.2s ease;
}

.save-keyword-button:hover:not(:disabled) {
    background-color: rgba(255, 255, 255, 0.1);
}

.save-keyword-button:disabled {
    cursor: not-allowed;
}

/* Animation for saving state */
.save-keyword-button.saving {
    animation: pulse 1.5s infinite;
}

@keyframes pulse {
    0%, 100% { opacity: 1; }
    50% { opacity: 0.5; }
}
`, "",{"version":3,"sources":["webpack://./src/shared/styles/history-insights.css"],"names":[],"mappings":"AAAA,2CAA2C;;AAE3C,uFAAuF;;AAEvF,oCAAoC;AACpC;IACI,eAAe;IACf,MAAM;IACN,QAAQ;IACR,YAAY,EAAE,sCAAsC;IACpD,aAAa;IACb,mBAAmB;IACnB,mCAAmC;IACnC,2BAA2B;IAC3B,4CAA4C;IAC5C,aAAa;IACb,sBAAsB;IACtB,eAAe;IACf,2BAA2B;IAC3B,sCAAsC;IACtC,0CAA0C;AAC9C;;AAEA,uEAAuE;;AAEvE,iCAAiC;AACjC;IACI,OAAO;IACP,gBAAgB,EAAE,0BAA0B;IAC5C,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,iBAAiB,EAAE,8DAA8D;IACjF,kDAAkD;IAClD,qBAAqB;IACrB,wBAAwB;AAC5B;;AAEA,iDAAiD,UAAU,EAAE,WAAW,EAAE;;AAE1E;IACI,uBAAuB;AAC3B;;AAEA;IACI,uCAAuC;IACvC,kBAAkB;AACtB;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,cAAc;IACd,aAAa,EAAE,2CAA2C;IAC1D,gBAAgB,EAAE,4BAA4B;AAClD;;AAEA,wBAAwB;AACxB;IACI,mBAAmB;IACnB,8CAA8C;IAC9C,cAAc;IACd,mBAAmB,EAAE,+DAA+D;IACpF,mBAAmB,EAAE,sCAAsC;IAC3D,kBAAkB;AACtB;;AAEA,gCAAgC;AAChC;IACI,kCAAkC;IAClC,kBAAkB;AACtB;;AAEA,yCAAyC;AACzC;IACI,kBAAkB;IAClB,QAAQ;IACR,QAAQ;IACR,2BAA2B;AAC/B;;AAEA,8CAA8C;AAC9C;IACI,uBAAuB;AAC3B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;AACtB;;AAEA,kDAAkD;AAClD;;IAEI,6BAA6B;IAC7B,aAAa;IACb,uBAAuB;IACvB,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;;IAEI,+BAA+B;IAC/B,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA,mCAAmC;AACnC;IACI,OAAO;IACP,iBAAiB,EAAE,gDAAgD;IACnE,aAAa;IACb,2CAA2C;AAC/C;;AAEA,0BAA0B;AAC1B;IACI,eAAe;IACf,QAAQ;IACR,UAAU;IACV,sBAAsB;IACtB,uBAAuB;IACvB,uBAAuB;IACvB,6BAA6B;IAC7B,qBAAqB;IACrB,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,aAAa;IACb,0BAA0B;IAC1B,gCAAgC;AACpC;;AAEA,mCAAmC;AACnC,wBAAwB,uBAAuB,EAAE,gCAAgC,EAAE;;AAEnF,iCAAiC;AACjC,6BAA6B,uBAAuB,EAAE,gCAAgC,EAAE;;AAExF;IACI,sBAAsB;IACtB,uBAAuB;IACvB,eAAe;AACnB;;AAEA,sCAAsC;AACtC;IACI;QACI,sBAAsB;QACtB,uBAAuB;IAC3B;;IAEA;QACI,sBAAsB;QACtB,uBAAuB;IAC3B;AACJ;;AAEA,gCAAgC;AAChC;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,YAAY;IACZ,aAAa;IACb,8BAA8B;IAC9B,eAAe;IACf,UAAU;IACV,kBAAkB;IAClB,mDAAmD;IACnD,aAAa,EAAE,uCAAuC;AAC1D;;AAEA;IACI,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,uBAAuB;AAC3B;;AAEA;IACI,qBAAqB;IACrB,qCAAqC;IACrC,2CAA2C;IAC3C,+BAA+B;AACnC;;AAEA;IACI,qCAAqC;IACrC,uCAAuC;IACvC,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,qBAAqB;IACrB,kDAAkD;AACtD;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,uCAAuC;IACvC,kBAAkB;AACtB;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;;IAEI,+BAA+B;AACnC;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,+BAA+B;IAC/B,uBAAuB;IACvB,SAAS;IACT,qBAAqB;IACrB,iDAAiD;AACrD;;AAEA;IACI,cAAc;IACd,kCAAkC;AACtC;;AAEA,8BAA8B;AAC9B;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,UAAU;IACV,YAAY;IACZ,kBAAkB;IAClB,eAAe,EAAE,kBAAkB;IACnC,uBAAuB;AAC3B;;AAEA;;IAEI,0EAA0E;AAC9E;;AAEA;IACI;QACI,YAAY;IAChB;AACJ;;AAEA;IACI;QACI,YAAY;QACZ,cAAc,EAAE,0CAA0C;QAC1D,iBAAiB;QACjB,2CAA2C;IAC/C;;IAEA,iCAAiC;IACjC;QACI,aAAa;IACjB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,QAAQ;QACR,UAAU;QACV,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA,2CAA2C;;IAE3C;QACI,eAAe;IACnB;;IAEA;QACI,0BAA0B;QAC1B,SAAS;IACb;AACJ;;AAEA,+BAA+B;AAC/B;IACI,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,mBAAmB;AACvB;;AAEA,+BAA+B;AAC/B;IACI,8BAA8B;AAClC;;AAEA;IACI,WAAW,UAAU,EAAE;IACvB,MAAM,YAAY,EAAE;AACxB","sourcesContent":["/* History Insights View - Sidebar Layout */\n\n/* Note: Removed overflow-y: hidden rule to allow page scrolling when sidebar is open */\n\n/* Main container - SIDEBAR LAYOUT */\n.history-insights-view {\n    position: fixed;\n    top: 0;\n    right: 0;\n    width: 500px; /* default, can be overridden inline */\n    height: 100vh;\n    background: #000000;\n    -webkit-backdrop-filter: blur(20px);\n    backdrop-filter: blur(20px);\n    border-left: 1px solid rgba(75, 85, 99, 0.2);\n    display: flex;\n    flex-direction: column;\n    z-index: 100002;\n    transform: translateX(100%);\n    transition: transform 0.3s ease-in-out;\n    box-shadow: -4px 0 20px rgba(0, 0, 0, 0.3);\n}\n\n/* Remove the old close button styles since we're using single toggle */\n\n/* Scrollable content container */\n.sidebar-scrollable-content {\n    flex: 1;\n    overflow-y: auto; /* show native scrollbar */\n    overflow-x: hidden;\n    display: flex;\n    flex-direction: column;\n    padding-top: 16px; /* More top spacing to avoid overlap with fixed close button */\n    /* Show native scrollbar for the history sidebar */\n    scrollbar-width: auto;\n    -ms-overflow-style: auto;\n}\n\n.sidebar-scrollable-content::-webkit-scrollbar { width: 8px; height: 8px; }\n\n.sidebar-scrollable-content::-webkit-scrollbar-track {\n    background: transparent;\n}\n\n.sidebar-scrollable-content::-webkit-scrollbar-thumb {\n    background-color: rgba(75, 85, 99, 0.3);\n    border-radius: 3px;\n}\n\n.sidebar-scrollable-content::-webkit-scrollbar-thumb:hover {\n    background-color: rgba(75, 85, 99, 0.6);\n}\n\n.history-insights-view.open {\n    transform: translateX(0);\n}\n\n.history-insights-view .insights-panel {\n    flex: 1 1 auto;\n    min-height: 0; /* allow inner content to size and scroll */\n    overflow: hidden; /* avoid double scrollbars */\n}\n\n/* History bar styling */\n.history-insights-view .history-bar {\n    background: #000000;\n    border-bottom: 1px solid rgba(75, 85, 99, 0.2);\n    flex-shrink: 0;\n    padding-right: 44px; /* ensure Clear All doesn't clash with top-right close button */\n    padding-top: 1.5rem; /* extra space above Recent Activity */\n    text-align: center;\n}\n\n/* Center the header container */\n.history-insights-view .history-bar .flex.items-center.justify-between {\n    justify-content: center !important;\n    position: relative;\n}\n\n/* Position Clear All button absolutely */\n.history-insights-view .history-bar .flex.items-center.justify-between button {\n    position: absolute;\n    right: 0;\n    top: 50%;\n    transform: translateY(-50%);\n}\n\n/* Center the Recent Activity title and icon */\n.history-insights-view .history-bar .flex.items-center.gap-3 {\n    justify-content: center;\n}\n\n.history-insights-view .history-bar > div:first-child {\n    justify-content: center;\n}\n\n.history-insights-view .history-bar h2 {\n    text-align: center;\n}\n\n/* Empty state styling - remove black background */\n.history-bar .text-center,\n.history-insights-view .text-center {\n    text-align: center !important;\n    padding: 1rem;\n    background: transparent;\n    border: none;\n    border-radius: 12px;\n    margin-top: 1rem;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.history-bar .text-center > div,\n.history-insights-view .text-center > div {\n    color: rgba(255, 255, 255, 0.3);\n    font-size: 0.75rem;\n    font-weight: 400;\n    letter-spacing: 0.01em;\n    line-height: 1.4;\n    text-align: center;\n}\n\n/* Stacked insights panel styling */\n.insights-panel-stacked {\n    flex: 1;\n    min-height: 400px; /* Minimum height to ensure content is visible */\n    margin-top: 0;\n    border-top: 1px solid rgba(75, 85, 99, 0.2);\n}\n\n/* History toggle button */\n.history-toggle {\n    position: fixed;\n    top: 4px;\n    right: 4px;\n    width: 40px !important;\n    height: 40px !important;\n    background: transparent;\n    -webkit-backdrop-filter: none;\n    backdrop-filter: none;\n    border: none;\n    border-radius: 6px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    z-index: 9999;\n    transition: all 0.15s ease;\n    color: rgba(255, 255, 255, 0.85);\n}\n\n/* Default state (closed) - hover */\n.history-toggle:hover { background: transparent; color: rgba(255, 255, 255, 0.95); }\n\n/* Open state - hover for close */\n.history-toggle.open:hover { background: transparent; color: rgba(255, 255, 255, 0.95); }\n\n.history-toggle svg {\n    width: 18px !important;\n    height: 18px !important;\n    stroke-width: 2;\n}\n\n/* Ensure desktop sizing is explicit */\n@media (min-width: 769px) {\n    .history-toggle {\n        width: 40px !important;\n        height: 40px !important;\n    }\n    \n    .history-toggle svg {\n        width: 18px !important;\n        height: 18px !important;\n    }\n}\n\n/* Backdrop overlay for mobile */\n.history-backdrop {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100vw;\n    height: 100vh;\n    background: rgba(0, 0, 0, 0.5);\n    z-index: 100001;\n    opacity: 0;\n    visibility: hidden;\n    transition: opacity 0.3s ease, visibility 0.3s ease;\n    display: none; /* Hidden by default, shown on mobile */\n}\n\n.history-backdrop.visible {\n    opacity: 1;\n    visibility: visible;\n}\n\n.history-insights-view h2 {\n    font-size: 0.95rem;\n    font-weight: 600;\n    color: #ffffff;\n    letter-spacing: -0.01em;\n}\n\n.history-insights-view .history-item {\n    border-radius: 9999px;\n    background: rgba(255, 255, 255, 0.06);\n    border: 1px solid rgba(255, 255, 255, 0.12);\n    color: rgba(229, 231, 235, 0.9);\n}\n\n.history-insights-view .history-item.selected {\n    background: rgba(255, 255, 255, 0.14);\n    border-color: rgba(255, 255, 255, 0.28);\n    color: #ffffff;\n}\n\n.history-insights-view .history-item .item-label {\n    color: inherit;\n}\n\n.history-insights-view .history-item:hover {\n    border-color: rgba(255, 255, 255, 0.16);\n}\n\n.history-insights-view .history-list {\n    scrollbar-width: thin;\n    scrollbar-color: rgba(75, 85, 99, 0.3) transparent;\n}\n\n.history-insights-view .history-list::-webkit-scrollbar {\n    height: 6px;\n}\n\n.history-insights-view .history-list::-webkit-scrollbar-track {\n    background: transparent;\n}\n\n.history-insights-view .history-list::-webkit-scrollbar-thumb {\n    background-color: rgba(75, 85, 99, 0.3);\n    border-radius: 3px;\n}\n\n.history-insights-view .history-list::-webkit-scrollbar-thumb:hover {\n    background-color: rgba(75, 85, 99, 0.6);\n}\n\n.history-insights-view .keywords-section h3,\n.history-insights-view .companies-section h3 {\n    color: rgba(209, 213, 219, 0.9);\n}\n\n.history-insights-view .history-item:hover {\n    transform: none;\n}\n\n.history-insights-view .history-remove-button {\n    color: rgba(156, 163, 175, 0.8);\n    background: transparent;\n    border: 0;\n    border-radius: 9999px;\n    transition: color 0.2s ease, background 0.2s ease;\n}\n\n.history-insights-view .history-remove-button:hover {\n    color: #fca5a5;\n    background: rgba(239, 68, 68, 0.1);\n}\n\n/* === RESPONSIVE DESIGN === */\n.history-resize-handle {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 6px;\n    height: 100%;\n    cursor: col-resize;\n    z-index: 100004; /* above content */\n    background: transparent;\n}\n\n.history-resize-handle:hover,\n.history-resize-handle.dragging {\n    background: linear-gradient(to right, rgba(255,255,255,0.08), transparent);\n}\n\n@media (max-width: 1200px) {\n    .history-insights-view {\n        width: 500px;\n    }\n}\n\n@media (max-width: 768px) {\n    .history-insights-view {\n        width: 100vw;\n        height: 100dvh; /* Use dynamic viewport height on mobile */\n        border-left: none;\n        border-top: 1px solid rgba(75, 85, 99, 0.2);\n    }\n\n    /* Hide resize handle on mobile */\n    .history-resize-handle {\n        display: none;\n    }\n    \n    .history-backdrop {\n        display: block;\n    }\n    \n    .history-toggle {\n        top: 4px;\n        right: 4px;\n        width: 40px;\n        height: 40px;\n    }\n    \n    .history-toggle svg {\n        width: 18px;\n        height: 18px;\n    }\n    \n    /* Mobile styles for single toggle button */\n    \n    .history-insights-view .history-bar {\n        padding: 0.5rem;\n    }\n    \n    .history-insights-view .history-bar .grid {\n        grid-template-columns: 1fr;\n        gap: 1rem;\n    }\n}\n\n/* Save keyword button styles */\n.save-keyword-button {\n    border-radius: 4px;\n    transition: all 0.2s ease;\n}\n\n.save-keyword-button:hover:not(:disabled) {\n    background-color: rgba(255, 255, 255, 0.1);\n}\n\n.save-keyword-button:disabled {\n    cursor: not-allowed;\n}\n\n/* Animation for saving state */\n.save-keyword-button.saving {\n    animation: pulse 1.5s infinite;\n}\n\n@keyframes pulse {\n    0%, 100% { opacity: 1; }\n    50% { opacity: 0.5; }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
